$(document).ready(function() {
    AOS.init({

        duration: 1000, // values from 0 to 3000, with step 50ms
        easing: 'ease', // default easing for AOS animations
        once: true, // whether animation should happen only once - while scrolling down
        mirror: false, // whether elements should animate out while scrolling past them
        anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

    });
    $(".menu-icon").click(function() {
        $(this).toggleClass("active")
        $(".menu").toggleClass("active")
    })


    $("section").mouseenter(function() {
        $(".js-about-drop-menu").removeClass("active");
        $(".js-about-drop").removeClass("active")
    })
    $(".js-about-drop").click(function(e) {
        // e.preventDefault()
        $(this).toggleClass("active");
        $(".js-about-drop-menu").toggleClass("active");
    })

    $(".js-about-drop").hover(function(e) {

        $(this).toggleClass("active");
        $(this).find(".js-about-drop-menu").toggleClass("active");
    })
    $(window).scroll(function() {
        var sc = $(window).scrollTop()
        if (sc > 100) {
            $(".header-trans").removeClass("bg-transparent")
            $(".header-trans").addClass("bg-transparent-active")
        } else {
            $(".header-trans").addClass("bg-transparent")
            $(".header-trans").removeClass("bg-transparent-active")

        }
    });















})